import { Maybe } from './globalTypes'

import productPopFragmentRawString from '../../fragments/ProductPopFragment.graphql'

export const productPopFragmentString = productPopFragmentRawString

export type ProductPopFragment = {
  __typename: 'ComponentExpandProductPop'
  id: string
  title: string
  description: Maybe<string>
  categoryId: Maybe<string>
  price: Maybe<number>
  sku: Maybe<string>
  ctaLabel: Maybe<string>
  ctaUrl: Maybe<string>
  images: Maybe<{
    url: string
  }>[]
}

export const isProductPopFragment = (
  fragment: any,
): fragment is ProductPopFragment =>
  fragment &&
  fragment.__typename === 'ComponentExpandProductPop' &&
  typeof fragment.id === 'string' &&
  typeof fragment.title === 'string' &&
  (fragment.description === null || typeof fragment.description === 'string') &&
  (fragment.categoryId === null || typeof fragment.categoryId === 'string') &&
  (fragment.price === null || typeof fragment.price === 'number') &&
  (fragment.sku === null || typeof fragment.sku === 'string') &&
  (fragment.ctaLabel === null || typeof fragment.ctaLabel === 'string') &&
  (fragment.ctaUrl === null || typeof fragment.ctaUrl === 'string') &&
  Array.isArray(fragment.images) &&
  fragment.images
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) =>
        accum && (next === null || (next && typeof next.url === 'string')),
      true,
    )
